module.exports = __webpack_public_path__ + "assets/img/logo-black-no-text.8b749305.png";